import SectionHeading from "@/pages/home/components/SectionHeading";
import { overviewStats, overviewFeatures } from "@/mocks/siteData";

export default function PlatformOverview() {
  return (
    <section id="overview" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="Platform Overview"
          title="蓝莓视频是什么，本页又能帮你做什么"
          desc="很多用户在搜索蓝莓视频时，真正的诉求并不是了解平台本身，而是“怎样稳定地找到它”。本页把这两件事分开讲清楚。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          <div className="lg:col-span-2 space-y-4 text-sm md:text-base leading-relaxed text-foreground-700">
            <p>
              蓝莓视频可以理解为一个以视频内容为核心的在线平台。用户通过浏览器访问它的首页，在其中浏览、查找并观看内容。由于访问入口、地址与线路会随着运营情况调整，很多人在一段时间不访问之后，就容易遇到“搜不到、进不去、进了又不对”的情况。
            </p>
            <p>
              本页因此把注意力放在<span className="text-foreground-950 font-medium">访问本身</span>：如何确认一个可靠的入口、如何获取当前有效的最新地址、打开首页后应该核对哪些信息，以及遇到打不开、加载慢、地址失效等问题时该按什么顺序排查。
            </p>
            <p>
              我们不会替你“记住”某一个地址，而是提供一套可以反复使用的方法。掌握了这套方法，即便地址发生变化，你也能按步骤找到正确的入口，而不是每次都从零开始搜索、在真假难分的页面里反复试错。
            </p>
            <div className="p-5 rounded-xl bg-accent-100/80 border border-accent-200">
              <p className="flex items-start gap-3 text-sm text-accent-900">
                <i className="ri-lightbulb-flash-line text-lg mt-0.5" />
                <span>
                  一句话概括：本页不提供某个“永久地址”，而是帮你建立一套
                  <strong className="font-medium">找入口、辨真伪、排故障</strong>
                  的通用方法。
                </span>
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 content-start">
            {overviewStats.map((stat) => (
              <div
                key={stat.label}
                className="p-5 rounded-xl bg-background-50 border border-background-200"
              >
                <p className="font-heading font-black text-foreground-950">
                  <span className="text-3xl md:text-4xl">{stat.value}</span>
                  <span className="text-sm ml-1 text-foreground-500">{stat.unit}</span>
                </p>
                <p className="mt-2 text-xs md:text-sm text-foreground-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {overviewFeatures.map((feature, index) => (
            <div
              key={feature.title}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className={`${feature.icon} text-xl`} />
                </span>
                <span className="text-xs font-label tracking-widest text-foreground-300">
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="mt-4 text-base font-heading font-bold text-foreground-950">
                {feature.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}